import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  // ============ 实习生页面 ============
  {
    path: '/student',
    name: 'StudentHome',
    component: () => import('../views/student/Home.vue'),
    meta: { title: '实习生工作台', role: 'student' }
  },
  {
    path: '/student/schedule',
    name: 'StudentSchedule',
    component: () => import('../views/student/Schedule.vue'),
    meta: { title: '我的排班', role: 'student' }
  },
  {
    path: '/student/attendance',
    name: 'StudentAttendance',
    component: () => import('../views/student/Attendance.vue'),
    meta: { title: '考勤打卡', role: 'student' }
  },
  {
    path: '/student/leave',
    name: 'StudentLeave',
    component: () => import('../views/student/Leave.vue'),
    meta: { title: '请假申请', role: 'student' }
  },
  {
    path: '/student/makeup',
    name: 'StudentMakeup',
    component: () => import('../views/student/Makeup.vue'),
    meta: { title: '补卡申请', role: 'student' }
  },
  {
    path: '/student/exam',
    name: 'StudentExam',
    component: () => import('../views/student/Exam.vue'),
    meta: { title: '理论考试', role: 'student' }
  },
  {
    path: '/student/exam/:id',
    name: 'StudentExamDetail',
    component: () => import('../views/student/ExamDetail.vue'),
    meta: { title: '答题', role: 'student' }
  },
  {
    path: '/student/feedback',
    name: 'StudentFeedback',
    component: () => import('../views/student/Feedback.vue'),
    meta: { title: '教学反馈', role: 'student' }
  },
  {
    path: '/student/transfer',
    name: 'StudentTransfer',
    component: () => import('../views/student/Transfer.vue'),
    meta: { title: '转科申请', role: 'student' }
  },
  {
    path: '/student/scores',
    name: 'StudentScores',
    component: () => import('../views/student/Scores.vue'),
    meta: { title: '我的成绩', role: 'student' }
  },
  {
    path: '/student/skill',
    name: 'StudentSkill',
    component: () => import('../views/student/Skill.vue'),
    meta: { title: '技能考核', role: 'student' }
  },
  {
    path: '/student/notifications',
    name: 'StudentNotifications',
    component: () => import('../views/student/Notification.vue'),
    meta: { title: '通知公告', role: 'student' }
  },
  {
    path: '/student/survey',
    name: 'StudentSurvey',
    component: () => import('../views/student/Survey.vue'),
    meta: { title: '问卷调查', role: 'student' }
  },
  {
    path: '/student/appraisal',
    name: 'StudentAppraisal',
    component: () => import('../views/student/Appraisal.vue'),
    meta: { title: '实习鉴定', role: 'student' }
  },
  {
    path: '/student/mine',
    name: 'StudentMine',
    component: () => import('../views/student/Mine.vue'),
    meta: { title: '我的', role: 'student' }
  },
  // ============ 带教老师页面 ============
  {
    path: '/teacher',
    name: 'TeacherHome',
    component: () => import('../views/teacher/Home.vue'),
    meta: { title: '带教工作台', role: 'teacher' }
  },
  {
    path: '/teacher/schedule',
    name: 'TeacherSchedule',
    component: () => import('../views/teacher/Schedule.vue'),
    meta: { title: '排班管理', role: 'teacher' }
  },
  {
    path: '/teacher/attendance-review',
    name: 'TeacherAttendanceReview',
    component: () => import('../views/teacher/AttendanceReview.vue'),
    meta: { title: '考勤审核', role: 'teacher' }
  },
  {
    path: '/teacher/theory',
    name: 'TeacherTheory',
    component: () => import('../views/teacher/Theory.vue'),
    meta: { title: '理论考核管理', role: 'teacher' }
  },
  {
    path: '/teacher/skill',
    name: 'TeacherSkill',
    component: () => import('../views/teacher/Skill.vue'),
    meta: { title: '技能考核管理', role: 'teacher' }
  },
  {
    path: '/teacher/evaluation',
    name: 'TeacherEvaluation',
    component: () => import('../views/teacher/Evaluation.vue'),
    meta: { title: '出科评价', role: 'teacher' }
  },
  {
    path: '/teacher/transfer-review',
    name: 'TeacherTransferReview',
    component: () => import('../views/teacher/TransferReview.vue'),
    meta: { title: '转科初审', role: 'teacher' }
  },
  {
    path: '/teacher/feedback-summary',
    name: 'TeacherFeedbackSummary',
    component: () => import('../views/teacher/FeedbackSummary.vue'),
    meta: { title: '反馈概况', role: 'teacher' }
  },
  {
    path: '/teacher/mine',
    name: 'TeacherMine',
    component: () => import('../views/teacher/Mine.vue'),
    meta: { title: '我的', role: 'teacher' }
  },
  // ============ 护士长页面 ============
  {
    path: '/head-nurse',
    name: 'HeadNurseHome',
    component: () => import('../views/headNurse/Home.vue'),
    meta: { title: '护士长工作台', role: 'headNurse' }
  },
  {
    path: '/head-nurse/transfer-approve',
    name: 'HeadNurseTransferApprove',
    component: () => import('../views/headNurse/TransferApprove.vue'),
    meta: { title: '批量终审', role: 'headNurse' }
  },
  {
    path: '/head-nurse/data-summary',
    name: 'HeadNurseDataSummary',
    component: () => import('../views/headNurse/DataSummary.vue'),
    meta: { title: '数据汇总', role: 'headNurse' }
  },
  {
    path: '/head-nurse/mine',
    name: 'HeadNurseMine',
    component: () => import('../views/headNurse/Mine.vue'),
    meta: { title: '我的', role: 'headNurse' }
  },
  // ============ 管理员页面 ============
  {
    path: '/admin',
    name: 'AdminHome',
    component: () => import('../views/admin/Home.vue'),
    meta: { title: '管理员工作台', role: 'admin' }
  },
  {
    path: '/admin/students',
    name: 'AdminStudents',
    component: () => import('../views/admin/Students.vue'),
    meta: { title: '实习生管理', role: 'admin' }
  },
  {
    path: '/admin/teachers',
    name: 'AdminTeachers',
    component: () => import('../views/admin/Teachers.vue'),
    meta: { title: '带教老师管理', role: 'admin' }
  },
  {
    path: '/admin/rotation',
    name: 'AdminRotation',
    component: () => import('../views/admin/Rotation.vue'),
    meta: { title: '轮转计划', role: 'admin' }
  },
  {
    path: '/admin/question-bank',
    name: 'AdminQuestionBank',
    component: () => import('../views/admin/QuestionBank.vue'),
    meta: { title: '题库管理', role: 'admin' }
  },
  {
    path: '/admin/survey',
    name: 'AdminSurvey',
    component: () => import('../views/admin/Survey.vue'),
    meta: { title: '问卷管理', role: 'admin' }
  },
  {
    path: '/admin/statistics',
    name: 'AdminStatistics',
    component: () => import('../views/admin/Statistics.vue'),
    meta: { title: '数据统计', role: 'admin' }
  },
  {
    path: '/admin/settings',
    name: 'AdminSettings',
    component: () => import('../views/admin/Settings.vue'),
    meta: { title: '系统配置', role: 'admin' }
  },
  {
    path: '/admin/transfer-review',
    name: 'AdminTransferReview',
    component: () => import('../views/admin/TransferReview.vue'),
    meta: { title: '转科审核', role: 'admin' }
  },
  {
    path: '/admin/mine',
    name: 'AdminMine',
    component: () => import('../views/admin/Mine.vue'),
    meta: { title: '我的', role: 'admin' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path !== '/login' && !localStorage.getItem('token')) {
    next('/login')
  } else {
    next()
  }
})

export default router
